import { Typography } from '@mui/material';
import MarkerSVG from 'assets/images/marker.svg?react';

const Legend = () => {
  return (
    <div className="legend-container">
      <Typography className="legend-title">Leyenda</Typography>

      <div className="legend-content">
        <div className="legend-icon">
          <MarkerSVG />
        </div>

        <ul className="legend-items">
          <li className="item">
            <div style={{ color: '#FFFFFF', fontSize: '16px' }}>n&#176;</div>
            <Typography className="text">Número de conectores</Typography>
          </li>
          <li className="item">
            <div className="icon" style={{ background: '#37BE6E' }}></div>
            <Typography className="text">Conectores disponibles</Typography>
          </li>
          <li className="item">
            <div className="icon" style={{ background: '#285ce4' }}></div>
            <Typography className="text">Conectores ocupados</Typography>
          </li>
          <li className="item">
            <div className="icon" style={{ background: '#7B7B7B' }}></div>
            <Typography className="text">Conectores no disponibles</Typography>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Legend;
